import { useEffect } from "react";
import { Mail, ArrowLeft, MessageCircle, ShieldCheck } from "lucide-react";

export default function Support() {
  useEffect(() => {
    document.title = "Support · Arvo";
  }, []);

  return (
    <main
      data-testid="support-page"
      className="min-h-screen bg-[#F9F8F6] text-[#1A1D1A] py-16"
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <a
          href="/"
          className="text-sm font-semibold text-[#2D4A22] hover:underline inline-flex items-center gap-1"
        >
          <ArrowLeft className="w-4 h-4" /> Back to site
        </a>

        <p className="mt-8 text-xs font-bold tracking-[0.18em] uppercase text-[#D96C32]">
          Arvo · Support
        </p>
        <h1 className="mt-1 font-display font-bold text-4xl sm:text-5xl tracking-tight">
          We&apos;re here to help.
        </h1>
        <p className="mt-4 text-lg text-[#4A4F4A]">
          A real person on the team will reply. No bots, no ticket queues — just an answer
          from someone who knows the app and the yards.
        </p>

        <div
          data-testid="support-email-card"
          className="mt-10 bg-white border border-[#D5D1C8] rounded-md p-6 sm:p-8 shadow-sm"
        >
          <div className="flex items-start gap-4">
            <span className="inline-flex w-12 h-12 items-center justify-center rounded-md bg-[#2D4A22] text-white flex-shrink-0">
              <Mail className="w-6 h-6" />
            </span>
            <div className="flex-1">
              <p className="text-xs font-bold tracking-wider uppercase text-[#4A4F4A]">
                Email us
              </p>
              <a
                href="mailto:support@getarvo.co.nz"
                data-testid="support-email-link"
                className="mt-1 inline-block font-display font-bold text-2xl sm:text-3xl text-[#1A1D1A] hover:text-[#2D4A22] underline-offset-4 hover:underline"
              >
                support@getarvo.co.nz
              </a>
              <p className="mt-3 text-sm text-[#4A4F4A] leading-relaxed">
                Use this for anything — getting started, importing your animal records,
                pairing your EID reader, app questions, privacy requests, or just a
                yarn about a feature you&apos;d like to see.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="bg-white border border-[#D5D1C8] rounded-md p-6">
            <MessageCircle className="w-5 h-5 text-[#2D4A22]" />
            <p className="mt-3 font-display font-bold text-base">Common questions</p>
            <p className="mt-1 text-sm text-[#4A4F4A]">
              Many quick answers (offline use, EID readers, data import, training) are on
              the homepage FAQ.
            </p>
            <a
              href="/#faq"
              className="mt-3 inline-block text-sm font-bold text-[#D96C32] hover:underline"
            >
              See FAQ →
            </a>
          </div>
          <div className="bg-white border border-[#D5D1C8] rounded-md p-6">
            <ShieldCheck className="w-5 h-5 text-[#2D4A22]" />
            <p className="mt-3 font-display font-bold text-base">Your data</p>
            <p className="mt-1 text-sm text-[#4A4F4A]">
              Independent, provider-neutral. Read our policy for what we do (and don&apos;t)
              collect.
            </p>
            <a
              href="/privacy"
              className="mt-3 inline-block text-sm font-bold text-[#D96C32] hover:underline"
            >
              Privacy Policy →
            </a>
          </div>
        </div>

        <p className="mt-12 pt-6 border-t border-[#D5D1C8] text-sm text-[#4A4F4A]">
          Arvo · Independent &amp; provider-neutral livestock data capture · Built in New
          Zealand
        </p>
      </div>
    </main>
  );
}
